import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'bgoPhoneNumberMask',
  pure: true,
})
export class PhoneNumberMaskPipe implements PipeTransform {
  readonly shownLength = 3

  transform(phoneNumber: string): string {
    phoneNumber = phoneNumber.replace('+41', '0')

    if (phoneNumber.length <= this.shownLength) {
      return phoneNumber
    }
    return phoneNumber.slice(0, this.shownLength)
  }
}
